import { IEmployeeFormMutations } from './mutations.types';
import {
  IDepartmentData,
  IEmployeeFormSubmissionChecklistData,
  IEmployeeFormSubmissionCommentData,
  IEmployeeFormSubmissionData,
  IUserData
} from '@/models';
import { IEmployeeFormState } from '../employee-form.types';
import { ITransition } from '@/models/transition';

export const mutations: IEmployeeFormMutations = {
  SET_COUNT(state: IEmployeeFormState, payload: number): void {
    state.count = payload;
  },

  INCREMENT_COUNT(state: IEmployeeFormState): void {
    state.count += 1;
  },

  DECREMENT_COUNT(state: IEmployeeFormState): void {
    state.count -= 1;
  },

  SET_EMPLOYEE_FORM_SUBMISSIONS(
    state: IEmployeeFormState,
    payload: IEmployeeFormSubmissionData[]
  ): void {
    state.employeeFormSubmissions = payload;
  },

  ADD_EMPLOYEE_FORM_SUBMISSION(
    state: IEmployeeFormState,
    payload: IEmployeeFormSubmissionData
  ): void {
    state.employeeFormSubmissions.unshift(payload);
  },

  UPDATE_EMPLOYEE_FORM_SUBMISSION(
    state: IEmployeeFormState,
    payload: IEmployeeFormSubmissionData
  ): void {
    const index = state.employeeFormSubmissions.findIndex(
      (submission: IEmployeeFormSubmissionData) => submission.id === payload.id
    );

    state.employeeFormSubmissions.splice(index, 1, payload);
  },

  REMOVE_EMPLOYEE_FORM_SUBMISSION(
    state: IEmployeeFormState,
    payload: number
  ): void {
    const index = state.employeeFormSubmissions.findIndex(
      (submission: IEmployeeFormSubmissionData) => submission.id === payload
    );

    state.employeeFormSubmissions.splice(index, 1);
  },

  SET_LAST_PROMISE(state: IEmployeeFormState, payload: Promise<any>): void {
    state.lastPromise = payload;
  },

  SET_CHECKLIST_ASSIGNEE_OPTIONS(
    state: IEmployeeFormState,
    payload: IUserData[]
  ): void {
    state.checklistAssigneeOptions = payload;
  },

  //templates
  SET_EMPLOYEE_FORM_CHECKLISTS(
    state: IEmployeeFormState,
    payload: IEmployeeFormSubmissionChecklistData[]
  ): void {
    state.employeeFormChecklists = payload;
  },

  ADD_EMPLOYEE_FORM_CHECKLIST(
    state: IEmployeeFormState,
    payload: IEmployeeFormSubmissionChecklistData
  ): void {
    state.employeeFormChecklists.push(payload);
  },

  UPDATE_EMPLOYEE_FORM_CHECKLIST(
    state: IEmployeeFormState,
    payload: IEmployeeFormSubmissionChecklistData
  ): void {
    const index = state.employeeFormChecklists.findIndex(
      (template: IEmployeeFormSubmissionChecklistData) =>
        template.id === payload.id
    );

    state.employeeFormChecklists.splice(index, 1, payload);
  },

  SET_EMPLOYEE_FORM_DEPARTMENTS(
    state: IEmployeeFormState,
    payload: IDepartmentData[]
  ): void {
    state.employeeFormDepartments = payload;
  },

  //comment
  SET_EMPLOYEE_FORM_SUBMISSION_COMMENTS(
    state: IEmployeeFormState,
    payload: IEmployeeFormSubmissionCommentData[]
  ): void {
    state.comments = payload;
  },

  ADD_EMPLOYEE_FORM_SUBMISSION_COMMENT(
    state: IEmployeeFormState,
    payload: IEmployeeFormSubmissionCommentData
  ): void {
    state.comments.unshift(payload);
  },

  UPDATE_EMPLOYEE_FORM_SUBMISSION_COMMENT(
    state: IEmployeeFormState,
    payload: IEmployeeFormSubmissionCommentData
  ): void {
    const index = state.comments.findIndex(
      (comment: IEmployeeFormSubmissionCommentData) => comment.id === payload.id
    );

    state.comments.splice(index, 1, payload);
  },

  REMOVE_EMPLOYEE_FORM_SUBMISSION_COMMENT(
    state: IEmployeeFormState,
    payload: number
  ): void {
    const index = state.comments.findIndex(
      (comment: IEmployeeFormSubmissionCommentData) => comment.id === payload
    );

    state.comments.splice(index, 1);
  },

  SET_EMPLOYEE_FORM_SUBMISSION_ACTIVITIES(
    state: IEmployeeFormState,
    payload: ITransition[]
  ): void {
    state.activities = payload;
  },

  SET_EMPLOYEE_FORM_MENTIONABLE_USERS(
    state: IEmployeeFormState,
    payload: IUserData[]
  ): void {
    state.mentionableUsers = payload;
  },

  SET_LAST_CREATED_COMMENT_ID(state, payload) {
    state.lastCreatedCommentId = payload;
  }
};
